import { z } from 'zod/v4'
import { publicKolInfoSchema } from '@/types/schema/kol/public-kol-info-schema'

export const influencerInfoSchema = publicKolInfoSchema.extend({
  is_radar_star: z.boolean(),
})

export type InfluencerInfo = z.infer<typeof influencerInfoSchema>
